module.exports = __webpack_public_path__ + "img/home-prize-4.c82dcb3b.png";